import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DriverDrawer from "components/drawer/DriverDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DriverServices from "services/DriverServices";
import ViewModal from "components/modal/ViewDriverModal";
import RejectModal from "components/modal/RejectModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState } from "react";

const DriverTable = ({ driver, perpage, currentPage }) => {
  const { title, serviceId } = useToggleDrawer();
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);

  const statusOptions = [
    { value: 0, label: "Created" },
    { value: 1, label: "Deleted" },
    { value: 2, label: "Waiting for Delete" },
    { value: 3, label: "Waiting for Approval" },
    { value: 4, label: "Waiting for Update" },
    { value: 5, label: "Canceled Update" },
    { value: 6, label: "Canceled Add" },
    { value: 7, label: "Canceled Delete" },
  ];

  const handleStatusChange = async (driverId, newStatus) => {
    if ([2, 3, 4].includes(newStatus)) {
      setSelectedDriver({ id: driverId, newStatus });
      setIsRemarkModalOpen(true);
    } else {
      // Handle direct status update for non-"Waiting" statuses
      try {
        const response = await DriverServices.updateStatus(driverId, newStatus);
        const result = await response.json();
        if (result.status) {
          alert("Status updated successfully!");
        } else {
          alert("Failed to update status.");
        }
      } catch (error) {
        console.error("Error updating status:", error);
        alert("Error updating status.");
      }
    }
  };

  const handleModalAction = async (action) => {
    try {
      if (action === "approve") {
        await DriverServices.updateStatus(
          selectedDriver.id,
          selectedDriver.newStatus
        );
        alert("Status approved successfully!");
      } else {
        alert("Status rejected.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedDriver(null);
    }
  };

  return (
    <>
      <ViewModal id={serviceId} title={title} data={driver} />
      <MainDrawer>
        <DriverDrawer id={serviceId} />
      </MainDrawer>
      
      {isRemarkModalOpen && (
        <RejectModal
        isOpen={isRemarkModalOpen}
        onClose={() => setIsRemarkModalOpen(false)}
        onAction={handleModalAction}
        title="Approve or Reject Status"
        message={`Are you sure you want to ${
          selectedDriver?.newStatus === 3
            ? "approve adding driver"
            : selectedDriver?.newStatus === 4
            ? "approve update this drive"
            : "approve this deletion"
        }?`}
      />
      )}

      <TableBody>
        {driver?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell>
              <span className="font-semibold uppercase text-xs">
                {(currentPage - 1) * perpage + index + 1}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.driver_name}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data["vendor_id"]}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data["driving_license"]}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm font-medium">{data.driver_contact_no}</span>
            </TableCell>

            <TableCell className="text-center">
              {data.status === 2 || data.status === 3 || data.status === 4 ? (
                <button
                  className="text-sm bg-yellow-500 text-white px-3 py-1 rounded"
                  onClick={() =>
                    handleStatusChange(data.id, parseInt(data.status))
                  }
                >
                  {statusOptions.find((option) => option.value === data.status)?.label}
                </button>
              ) : (
                <span className="text-sm font-medium">
                  {statusOptions.find((option) => option.value === data.status)?.label}
                </span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default DriverTable;
